import React from 'react';
import AttachmentIcon from '@rsuite/icons/Attachment';
import CloseIcon from '@rsuite/icons/Close';
import { Icon } from '@rsuite/icons';

export default function FileList({
  files,
  onDeleteByHash
}) {
  return (
    <>
      {files && files.length > 0 && (
        <div className="app-uploader rs-uploader rs-uploader-text">
          <div className="rs-uploader-file-items">
            {files.map(file => (
              <div key={file.hash} className="rs-uploader-file-item rs-uploader-file-item-text">
                <div className="rs-uploader-file-item-icon-wrapper">
                  <Icon as={AttachmentIcon} />
                </div>
                <div className="rs-uploader-file-item-panel">
                  <div className="rs-uploader-file-item-content">
                    <div className="rs-uploader-file-item-title">{file.name}</div>
                  </div>
                </div>
                <span
                  role="button"
                  className="rs-uploader-file-item-btn-remove rs-btn-close"
                  onClick={() => onDeleteByHash(file.hash)}>
                <Icon as={CloseIcon} />
              </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  )
}
